import React from "react";
import { formatNumber } from "../../utils/dashboardFormat";

const DeliveryStrip = ({ deliveryStats = {}, messages = {} }) => {
    const completed = deliveryStats.completed ?? 0;
    const queue = deliveryStats.queue ?? 0;
    const failed = deliveryStats.failed ?? 0;
    const successRate = messages.successRateToday;

    const items = [
        { key: "completed", label: "Completed", value: completed, className: "completed" },
        { key: "queue", label: "Queue", value: queue, className: "queue" },
        { key: "failed", label: "Failed", value: failed, className: "failed" },
    ];

    return (
        <div className="mt-4">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <div>
                    <h6 className="mb-0 text-lg">Today’s delivery</h6>
                    <p className="mb-0 text-secondary-light text-sm">Completed · Queue · Failed</p>
                </div>
                {successRate != null && (
                    <span className="dash-success-rate">
                        Success rate today: {Number(successRate).toFixed(1)}%
                    </span>
                )}
            </div>
            <div className="row g-3">
                {items.map((item) => (
                    <div className="col-md-4 col-sm-4 col-12" key={item.key}>
                        <div className={`card dash-delivery-card ${item.className} h-100`}>
                            <div className="card-body p-16">
                                <p className="dash-delivery-label">{item.label}</p>
                                <p className="dash-delivery-value">{formatNumber(item.value)}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DeliveryStrip;
